import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";
import Footer from "../components/Footer";

export default function CartPage({ onNav }) {
  const { cart, dispatch, cartTotal, notify, appliedCoupon, applyCoupon, removeCoupon, discount, coupons, adminWhatsApp, freeShipThreshold, shippingFee } = useStore();
  const [couponInput, setCouponInput] = useState("");
  const ship = (cartTotal - discount) >= freeShipThreshold ? 0 : shippingFee;
  const grandTotal = cartTotal - discount + ship;

  if (!cart.length) return (
    <div className="page-top-pad" style={{ background:"white", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", minHeight:"80vh", textAlign:"center", padding:"80px 20px" }}>
      <div style={{ fontSize:64, marginBottom:16 }}>🛒</div>
      <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:26, fontWeight:900, color:"#1a1a2e", marginBottom:12 }}>Your cart is empty</h2>
      <button onClick={()=>onNav("shop")} style={{ background:"#EC4899", color:"white", border:"none", padding:"13px 32px", borderRadius:50, fontSize:14, fontWeight:700, cursor:"pointer" }}>Shop Now</button>
    </div>
  );

  const waMsg = encodeURIComponent(
    "🛍️ *Order — Matchwell*\n\n" +
    cart.map(i=>`• *${i.name}*\n  ${i.sc} | ${i.ss} | ×${i.qty} = ₹${(i.price*i.qty).toLocaleString("en-IN")}${i.img?`\n  ${i.img}`:""}`).join("\n\n") +
    `\n\n*Total: ₹${grandTotal.toLocaleString("en-IN")}*`
  );

  const handleApply = () => {
    if (!couponInput.trim()) return;
    const ok = applyCoupon(couponInput);
    if (ok) setCouponInput("");
  };

  return (
    <div className="page-top-pad" style={{ background:"#fafafa", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"20px clamp(14px,4vw,40px)" }}>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(20px,4vw,32px)", fontWeight:900, color:"white" }}>Your Cart</h1>
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:16, padding:"16px clamp(12px,3vw,28px)", maxWidth:1100, margin:"0 auto" }}>
        <style>{`@media(min-width:768px){.cart-grid{flex-direction:row!important;}}`}</style>
        <div className="cart-grid" style={{ display:"flex", flexDirection:"column", gap:16, alignItems:"start" }}>
        {/* Items */}
        <div>
          {cart.map(item=>{
            const meta = CAT_META[item.category]||{color:"#EC4899",light:"#FDF2F8",emoji:"👗"};
            return (
              <div key={item.k} style={{ background:"white", borderRadius:14, padding:14, marginBottom:10, display:"flex", gap:12, alignItems:"flex-start", boxShadow:"0 2px 12px rgba(0,0,0,0.05)" }}>
                <div style={{ width:70, height:80, background:item.img?"white":meta.light, borderRadius:10, flexShrink:0, overflow:"hidden", display:"flex", alignItems:"center", justifyContent:"center", fontSize:24 }}>
                  {item.img?<img src={item.img} style={{width:"100%",height:"100%",objectFit:"cover",objectPosition:"top"}} alt=""/>:<span style={{opacity:0.4}}>{meta.emoji}</span>}
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontWeight:700, fontSize:14, color:"#1a1a2e", marginBottom:2, cursor:"pointer" }} onClick={()=>onNav("product",item.id)}>{item.name}</div>
                  <div style={{ fontSize:11, color:"#999", marginBottom:8 }}>{item.sc} · {item.ss}</div>
                  <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
                    <div style={{ display:"flex", alignItems:"center", border:"1px solid #e5e5e5", borderRadius:50 }}>
                      <button onClick={()=>dispatch({type:"QTY",k:item.k,d:-1})} style={{width:28,height:28,border:"none",background:"none",cursor:"pointer",fontSize:14,color:"#1a1a2e"}}>−</button>
                      <span style={{width:26,textAlign:"center",fontSize:13,fontWeight:700}}>{item.qty}</span>
                      <button onClick={()=>dispatch({type:"QTY",k:item.k,d:1})} style={{width:28,height:28,border:"none",background:"none",cursor:"pointer",fontSize:14,color:"#1a1a2e"}}>+</button>
                    </div>
                    <button onClick={()=>{dispatch({type:"REM",k:item.k});notify("Removed");}} style={{fontSize:11,color:"#EF4444",background:"none",border:"none",cursor:"pointer",fontWeight:600}}>Remove</button>
                  </div>
                </div>
                <div style={{ textAlign:"right", flexShrink:0 }}>
                  <div style={{ fontWeight:800, fontSize:15, color:"#1a1a2e" }}>₹{(item.price*item.qty).toLocaleString("en-IN")}</div>
                  <div style={{ fontSize:11, color:"#aaa" }}>₹{item.price} each</div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Summary */}
        <div style={{ background:"white", borderRadius:16, padding:20, boxShadow:"0 4px 24px rgba(0,0,0,0.07)", width:"100%" }}>
          <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, fontWeight:700, color:"#1a1a2e", marginBottom:16 }}>Order Summary</h3>

          {/* Coupon */}
          {appliedCoupon ? (
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", background:"#F0FDF4", border:"1px solid #86EFAC", borderRadius:10, padding:"10px 14px", marginBottom:14 }}>
              <div>
                <div style={{ fontSize:12, fontWeight:800, color:"#16A34A" }}>🎟️ {appliedCoupon} applied</div>
                <div style={{ fontSize:11, color:"#16A34A" }}>You saved ₹{discount.toLocaleString("en-IN")}</div>
              </div>
              <button onClick={removeCoupon} style={{ background:"none", border:"none", color:"#EF4444", fontSize:11, fontWeight:700, cursor:"pointer" }}>Remove</button>
            </div>
          ) : (
            <div style={{ display:"flex", gap:8, marginBottom:14 }}>
              <input value={couponInput} onChange={e=>setCouponInput(e.target.value)} placeholder="Enter coupon code"
                onKeyDown={e=>e.key==="Enter"&&handleApply()}
                style={{ flex:1, padding:"9px 14px", border:"1px solid #e5e5e5", borderRadius:8, fontSize:13, outline:"none", textTransform:"uppercase" }}/>
              <button onClick={handleApply} style={{ padding:"9px 18px", background:"#1a1a2e", color:"white", border:"none", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer" }}>Apply</button>
            </div>
          )}
          {!appliedCoupon && Object.entries(coupons).filter(([,def])=>def.active!==false).length > 0 && (
            <div style={{ fontSize:10, color:"#999", marginBottom:14, marginTop:-8 }}>
              Try: {Object.entries(coupons).filter(([,def])=>def.active!==false).map(([code,def])=>`${code} (${def.label})`).join(" · ")}
            </div>
          )}

          {[["Subtotal",`₹${cartTotal.toLocaleString("en-IN")}`]].map(([k,v])=>(
            <div key={k} style={{ display:"flex", justifyContent:"space-between", fontSize:13, marginBottom:8, color:"#666" }}>
              <span>{k}</span><span style={{ color:"#1a1a2e" }}>{v}</span>
            </div>
          ))}
          {discount > 0 && (
            <div style={{ display:"flex", justifyContent:"space-between", fontSize:13, marginBottom:8, color:"#16A34A", fontWeight:700 }}>
              <span>Coupon discount</span><span>-₹{discount.toLocaleString("en-IN")}</span>
            </div>
          )}
          <div style={{ display:"flex", justifyContent:"space-between", fontSize:13, marginBottom:8, color:"#666" }}>
            <span>Shipping</span><span style={{ color:ship===0?"#16A34A":"#1a1a2e", fontWeight:ship===0?800:400 }}>{ship===0?"FREE":"₹"+ship}</span>
          </div>
          <div style={{ borderTop:"2px solid #f0f0f0", paddingTop:10, marginBottom:16, display:"flex", justifyContent:"space-between" }}>
            <span style={{ fontWeight:800, fontSize:15 }}>Total</span>
            <span style={{ fontFamily:"'Playfair Display',serif", fontSize:20, fontWeight:900, color:"#1a1a2e" }}>₹{grandTotal.toLocaleString("en-IN")}</span>
          </div>
          {(cartTotal-discount)<freeShipThreshold && <div style={{ background:"#FFF7ED", border:"1px solid #FED7AA", padding:"8px 12px", borderRadius:8, fontSize:11, color:"#EA580C", marginBottom:14, fontWeight:600 }}>Add ₹{(freeShipThreshold-(cartTotal-discount)).toLocaleString("en-IN")} more for FREE delivery!</div>}
          <button onClick={()=>onNav("checkout")} style={{ width:"100%", padding:"13px", background:"#EC4899", color:"white", border:"none", borderRadius:50, fontSize:14, fontWeight:800, cursor:"pointer", marginBottom:8 }}>
            Checkout →
          </button>
          <a href={`https://wa.me/${adminWhatsApp}?text=${waMsg}`} target="_blank" rel="noreferrer"
            style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:8, background:"#F0FDF4", border:"1px solid #86EFAC", padding:"11px", borderRadius:50, fontSize:12, fontWeight:700, color:"#16A34A", textDecoration:"none", marginBottom:8 }}>
            💬 Order via WhatsApp
          </a>
          <button onClick={()=>onNav("shop")} style={{ width:"100%", padding:"10px", background:"white", color:"#1a1a2e", border:"1px solid #e5e5e5", borderRadius:50, fontSize:12, fontWeight:600, cursor:"pointer" }}>
            Continue Shopping
          </button>
        </div>
        </div>
      </div>
      <Footer onNav={onNav}/>
    </div>
  );
}
